import { render, staticRenderFns } from "./Detail-Salary.vue?vue&type=template&id=17df7f00&"
import script from "./Detail-Salary.vue?vue&type=script&lang=js&"
export * from "./Detail-Salary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports